import React, { useContext } from "react";
import "./TextInput.css";
import { useTranslation } from 'react-i18next';
import { ThemeContext } from "../../../../..";

const TextInput = ({
  name,
  openMapHandler,
  maxLength,
  errors,
  register,
  label,
  type,
  mandatory,
  value,
  disabled = false,
  style,
  uploadfilewidth
}) => {
  const { onChange, ...registerParams } = register(name);
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);

  // If maxLength is null or undefined, apply no limit (undefined means no maxLength attribute);
  const effectiveMaxLength = maxLength === null ? maxLength = undefined : maxLength = 200;


  return (
    <div className="input_text-form">
      <div className="input_text-form flexbox">

        <label style={{ color: theme === "light" ? "black" : undefined }}>
          {t(label)}
          {mandatory && <span className="asterisk">*</span>}
        </label>
        {name === 'latitude' && <span className="facility_maplink--position" onClick={openMapHandler}>
          {uploadfilewidth ? "" : t("locateonmap")}
        </span>}
      </div>
      <input
        maxLength={effectiveMaxLength}
        autoComplete="off"
        className={`form-control  ${theme === "light" ? "form-control-sm-light" : "form-control"
          } ${errors[name] ? "error__border--color" : "form__input"
          }`}
        type={type}
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
        {...registerParams}
        style={style}
      />
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default TextInput; 
